import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName: string) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';
import { renderReact } from '../../fragmentHelper/renderReactCustom';

import EconomicOperatorModule from '@rakutenfrance/legal-economic-operator';
import { regroupModuleReducers, getServerSidePropsLoader } from '@rakutenfrance/redux-apollo-helper';
import { tolgeeModule } from '@rakutenfrance/tolgee-provider';
import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import { GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types';

const { EconomicOperatorContainer } = EconomicOperatorModule.containers;

const modules = [EconomicOperatorModule, tolgeeModule];

const reducers = regroupModuleReducers(modules);

const WrappedEconomicOperator: React.FC<PagePropsType & { graphQlvariables: any, advertCrewModale: any }> = ({
  // eslint-disable-next-line react/prop-types
  initialApolloState,
  // eslint-disable-next-line react/prop-types
  initialReduxState,
  // eslint-disable-next-line react/prop-types
  moduleName,
}) => {
  return (
    <ReduxApolloFragmentWrapperChildren
    initialApolloState={initialApolloState}
    initialReduxState={initialReduxState}
    moduleName={moduleName}
    reducers={reducers}
  >
    <EconomicOperatorContainer />
  </ReduxApolloFragmentWrapperChildren>
  );
};

export const serverCanCache = true;

export const renderFunction = renderReact('EconomicOperator', WrappedEconomicOperator);


export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext) => {
  const baseUrl = "";
  const preloadedConfig = {};
  const graphQlVariables = {};
  const graphQlQuery = '';

  const { initialReduxState, initialApolloState } = await getServerSidePropsLoader(
    watchContext,
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables
  );

  return {
    props: {
      initialReduxState,
      initialApolloState,
    },
  };
};